<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Get Paid More and Promoted Faster</title>
<link href="CSS_1.css" rel="stylesheet" type="text/css"/>
<div class="coverpage" id="d14e31">
<img alt="cover" src="images/cover.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// CoverPage.vue?343cfefc